import React from 'react';
import i18n from 'i18next';

import LoyaltyClubForm from '../../common/customer.loyalty-club-form';
import ModalHeader from '../common/modal/header';

const { UI, Order, Customer } = Mobi2Go;

Order.onReady(() => {
    const closeModal = () => modal.close();
    const modal = UI.ExternalModal.create(
        'customer-loyalty-club-form',
        <div className="m2g-customer-loyalty-club-form-modal">
            <ModalHeader
                headerText={i18n.t('loyalty-club:title')}
                onClose={closeModal}
            />
            <div className="m2g-customer-loyalty-club-form-container m2g-modal-body">
                <LoyaltyClubForm
                    onCancel={closeModal}
                    onComplete={closeModal}
                />
            </div>
        </div>,
        {
            'data-view': 'customer-loyalty-club-form',
            className: 'm2g-customer-loyalty-club-form',
        }
    );

    modal.mount();

    UI.bind('showLoyaltyClubForm', () => {
        if (
            !Customer.isLoggedIn() ||
            !Mobi2Go.headoffice.customer_loyalty_club_enabled
        ) {
            return;
        }
        modal.open();
    });
});
